interface HeroNumberProps {
  label: string;
  value: string;
  sub?: string;
  size?: 'xl' | 'lg' | 'md';
  accent?: boolean;
}

export function HeroNumber({ label, value, sub, size = 'xl', accent = false }: HeroNumberProps) {
  const fontSize = size === 'xl' ? '48px' : size === 'lg' ? '36px' : '28px';
  const color = accent ? 'var(--accent)' : 'var(--text-primary)';

  return (
    <div>
      <div style={{
        fontSize,
        fontWeight: 500,
        letterSpacing: '-0.04em',
        lineHeight: 1,
        color,
        fontVariantNumeric: 'tabular-nums',
      }}>
        {value}
      </div>
      <div style={{
        fontSize: '11px',
        fontWeight: 500,
        textTransform: 'uppercase',
        letterSpacing: '0.1em',
        color: accent ? 'var(--accent)' : 'var(--text-muted)',
        marginTop: '8px',
        opacity: accent ? 0.8 : 1,
      }}>
        {label}
      </div>
      {sub && (
        <div style={{
          fontSize: '11px',
          color: 'var(--text-muted)',
          marginTop: '3px',
          opacity: 0.6,
        }}>
          {sub}
        </div>
      )}
    </div>
  );
}
